module.exports = __webpack_public_path__ + "671a1fb4fdd17a74f030633523cf68e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/simple-red-s.png
// module id = 2439
// module chunks = 0